import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classnames from 'classnames';

import PureRenderComponent from '../PureRenderComponent';
import Station from '../../records/Station';
import Icon from '../general/Icon';

class FareStations extends PureRenderComponent {

    static propTypes = {
        origin: PropTypes.instanceOf(Station).isRequired,
        destination: PropTypes.instanceOf(Station).isRequired,
        isReturn: PropTypes.bool,
        forceFontWeight: PropTypes.bool,
        className: PropTypes.string
    };

    static defaultProps = {
        origin: {},
        destination: {},
        isReturn: false,
        forceFontWeight: true
    };

    render () {
        const { origin, destination, isReturn, forceFontWeight, className } = this.props;
        const ReturnIcon = <Icon icon="switch" className="otrl-rotate-90"/>;
        const SingleIcon = <Icon icon="arrowback" className="otrl-rotate-180"/>;
        const classes = classnames('table-cell', {
            'text-weight--normal': forceFontWeight
        });

        return (
            <div className={classnames("like-table fare-stations", className)}>
                <div className="table-row">
                    <div className={ classes }>{ _.get(origin, 'name') || '' }</div>
                    <div className="table-cell direction text-center">{ isReturn ? ReturnIcon : SingleIcon }</div>
                    <div className={ classes }>{ _.get(destination, 'name') || '' }</div>
                </div>
            </div>
        );
    }

}

export default FareStations;
